import { useTranslation } from "react-i18next";

function AchieveMore() {

  const { t } = useTranslation();

  return (
    <div className="relative pt-[80px] xl:pt-[160px] overflow-hidden">
      <div className="max-w-[1220px] mx-[20px] xl:mx-auto">
        <div className="flex flex-col xl:flex-row justify-between">
            <div>
                <p className="text-[24px] xl:text-[36px] zen-dots leading-[1.2] text-[#FFF] xl:max-w-[413px]">{t('aboutus.3')}</p>
                <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[393px] mt-[20px] xl:mt-[40px]">{t('aboutus.4')}</p>
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-y-[30px] xl:gap-y-[40px] mt-[40px] xl:mt-0">
                <div className="flex gap-[8px]">
                    <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                    <div className="">
                        <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('aboutus.5')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[335px] mt-[12px]">{t('aboutus.6')}</p>
                    </div>
                </div>
                <div className="flex gap-[8px]">
                    <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                    <div className="">
                        <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('aboutus.7')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[335px] mt-[12px]">{t('aboutus.8')}</p>
                    </div>
                </div>
                <div className="flex gap-[8px]">
                    <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                    <div className="">
                        <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('aboutus.9')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[335px] mt-[12px]">{t('aboutus.10')}</p>
                    </div>
                </div>
                <div className="flex gap-[8px]">
                    <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                    <div className="">
                        <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('aboutus.11')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[335px] mt-[12px]">{t('aboutus.12')}</p>
                    </div>
                </div>
                <div className="flex gap-[8px]">
                    <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                    <div className="">
                        <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('aboutus.13')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[335px] mt-[12px]">{t('aboutus.14')}</p>
                    </div>
                </div>
                <div className="flex gap-[8px]">
                    <div className="w-[2px] h-[18px] bg-[#1E1C21] mt-[6px]"></div>
                    <div className="">
                        <p className="zen-dots text-[16px] xl:text-[20px] text-[#FFF]">{t('aboutus.15')}</p>
                        <p className="text-[12px] xl:text-[14px] text-[#FFFFFFB2] ibm-plex xl:max-w-[335px] mt-[12px]">{t('aboutus.16')}</p>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default AchieveMore;
